export const scheduleWhenIdle = (callback: () => void) => {
  if (typeof requestIdleCallback === 'function') {
    const idleHandle = requestIdleCallback(callback, { timeout: 10_000 });

    return () => cancelIdleCallback(idleHandle);
  }

  const timeoutHandle = setTimeout(callback, 2_000);

  return () => clearTimeout(timeoutHandle);
};
